export type ProgrammationTab = 'macro' | 'lookahead' | 'weekly'

export interface ProgrammationNavigationItem {
  id: ProgrammationTab
  icon: string
  itemWidth: number
  path: string
  translationKey: string
}

export const PROGRAMMATION_NAVIGATION: ProgrammationNavigationItem[] = [
  {
    id: 'macro',
    icon: 'icon-macro',
    itemWidth: 130,
    path: '/programmation-macro',
    translationKey: 'NAVIGATION:ProgrammationMacro',
  },
  {
    id: 'lookahead',
    icon: 'icon-lookahead',
    itemWidth: 162,
    path: '/programmation-lookahead',
    translationKey: 'NAVIGATION:ProgrammationLookahead',
  },
  {
    id: 'weekly',
    icon: 'icon-semanal',
    itemWidth: 150,
    path: '/programmation-weekly',
    translationKey: 'NAVIGATION:ProgrammationWeekly',
  },
]
